class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);

    document.addEventListener("MAKEBECOOL_BUNDLES.updateCart", this.refreshCart.bind(this, true));
    document.addEventListener("MAKEBECOOL_BUNDLES.applyShopifyDiscount", this.refreshCart.bind(this, false));
  }

  // Kite can update the gift just after Shopify accepts a code. Re-read the
  // drawer section without navigating so the gift line and rewards remain in
  // sync if the app adds/removes the gift asynchronously.
  refreshAfterDiscount() {
    [400, 1200, 2400].forEach((delay) => {
      setTimeout(() => {
        if (this.drawer?.querySelector('details[open]')) this.refreshCart(false);
      }, delay);
    });
  }

    async refreshCart(open = false) {
    try {
      const sections = this.getSectionsToRender();
      const sectionQuery = sections.map(s => s.section).join(',');

      const url = `${window.location.pathname}?sections=${encodeURIComponent(sectionQuery)}`;
      const res = await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
      });

      if (!res.ok) throw new Error(`Failed to fetch sections: ${res.status}`);

      const htmlBySection = await res.json();

      const sectionsById = sections.reduce((acc, s) => {
        acc[s.id] = htmlBySection[s.section];
        return acc;
      }, {});

      this.renderContents({ id: this.productId ?? null, sections: sectionsById }, open);
    } catch (e) {
      console.error('[MiniCart.refreshCart] ', e);
    }
  }


  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState, open) {
    this.productId = parsedState.id;

    // While the drawer is open (upsell adds, gift wrap, quick view),
    // patch the money-touched regions instead of swapping the whole
    // drawer — keeps open collapsibles, scroll and upsell state intact.
    const drawerOpen = this.drawer && !!this.drawer.querySelector('details[open]');

    this.getSectionsToRender().forEach((section => {
      if (!document.getElementById(section.id)) return;

      if (
        section.id === 'mini-cart' &&
        drawerOpen &&
        window.theme && theme.patchMiniCart &&
        parsedState.sections[section.id] &&
        theme.patchMiniCart(this.getSectionInnerHTML(parsedState.sections[section.id], section.selector))
      ) return;

      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    if (open) this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
